import { observable, action, runInAction, toJS } from "mobx";
import { message } from "antd";

class Store {

    @observable hotel = []; //酒店列表
    @observable hotelTotal = [];
    @observable group = [];  //自定义表格列表

    // 总部人员查询权限范围内的酒店信息
    getHeadquartersHotels = () => {
        return new Promise((res, rej) => {
            if (this.hotelTotal.length > 0) {
                res(toJS(this.hotelTotal));
                return
            }
            fetch('/getHeadquartersHotels', { credentials: 'include' }).then(x => x.json()).then(x => {
                if (x.status == 1) {
                    runInAction(() => {
                        this.hotel = x.data.hotels || [];
                        this.hotelTotal = x.data.hotels || [];
                        this.group = x.data.group || [];
                    });
                    res(x.data.hotels || [])
                } else {
                    rej('数据获取失败！');
                }
            }).catch(err => {
                rej(err);
            })
        });
    }

    @observable hotelInfo = {}; //当前酒店信息

    getHotelInfo = () => {
        return new Promise((res, rej) => {

            //如果数据存在禁止重复请求

            if (this.hotelInfo.id) {
                res(this.hotelInfo);
                return
            }

            fetch('/getHotelInfo', { credentials: 'include' }).then(x => x.json()).then(x => {
                runInAction(() => {
                    this.hotelInfo = x.data[0] ? x.data[0] : {};
                });
                res(x.data[0] ? x.data[0] : {});
            }).catch(err => {
                rej(err);
            })
        });
    }

    // 当前登录用户信息
    @observable userInfo = {};

    getUserInfo = () => {
        return new Promise((res, rej) => {
            if (this.userInfo.id) {
                res(this.userInfo);
                return
            }
            fetch('/getUserInfo', { credentials: 'include' }).then(x => x.json()).then((x) => {
                runInAction(() => {
                    this.userInfo = x.data || {};
                });
                res(x.data || {});
            }).catch(err => {
                rej(err);
            })
        });
    }


    // 手动清除数据
    @action
    onClearData = () => {
        this.userInfo = {};
        this.hotelInfo = {};
        this.hotel = [];
        this.hotelTotal = [];
        this.group = [];
    }

    @action
    onLogout = (props) => {
        var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
        if (keys) {
            for (var i = keys.length; i--;)
                document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
        };
        sessionStorage.clear();
        message.info('退出成功！');
        this.onClearData();
        props.store.tableSwitch.onClearData();
        window.location.href = '/#/login';

    }

    @observable display = '';

    @action
    onChangeDisplay = (value = "") => {
        this.display = value;
    }

}

const menu = new Store();

export default menu;


// WEBPACK FOOTER //
// ./src/store/menu/index.js